import { render, staticRenderFns } from "./BrandVoiceTable.vue?vue&type=template&id=c4f0ff04&scoped=true"
import script from "./BrandVoiceTable.vue?vue&type=script&lang=js"
export * from "./BrandVoiceTable.vue?vue&type=script&lang=js"
import style0 from "./BrandVoiceTable.vue?vue&type=style&index=0&id=c4f0ff04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f0ff04",
  null
  
)

export default component.exports